// extracted by mini-css-extract-plugin
export default {"badge":"NPiwZ5","up":"JXKBQd","down":"zQ1UcO","unknown":"J6HvqM"};